export default {
  inject: ['controlador'],
  props: {
    lote: {required: false},
    leilao: {required: false}
  }
}
